import { Box } from '@mui/material';
import { Formik } from 'formik';
import { useMemo } from 'react';
import { useMutation } from 'react-query';
import { useRecoilStateLoadable } from 'recoil';
import * as Yup from 'yup';

import { FormikTextField } from '../../../common/formik-material-ui';
import { trackSaveAddPort } from '../../../common/userTracking';
import { user } from '../../../recoil/atoms/user';
import { getApiMutation } from '../../../services/rest/getApiMutation';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';

import { ModalWithStyles } from './ModalWithStyles';

export function AddPortModal({
  show,
  handleClose,
  enqueueSnackbarWithStyles,
  methodNameEnum,
  refetchBusinessNumbers,
}) {
  const portSchema = useMemo(
    () =>
      Yup.object({
        number: Yup.number()
          .required('Required')
          .typeError('Must be in E.164 phone number format'),
        cost: Yup.number().required('Required').typeError('Must be a number'),
        numberName: Yup.string().max(
          100,
          'Name must be a maximum of 100 characters'
        ),
      }),
    []
  );
  const [userAtom, setUserAtom] = useRecoilStateLoadable(user);
  const mutation = useMutation(getApiMutation(userAtom.contents, setUserAtom));

  const { treatment } = useFeatureFlag('DASH-172-number-input-is-cut-off');
  const isPreventCutOffEnabled = useMemo(
    () => treatment === 'control' || treatment === 'on',
    [treatment]
  );

  return (
    <Formik
      onSubmit={async (values, actions) => {
        // const { response } = await makeRequest({
        //   methodName: methodNameEnum.ADD_PORT,
        //   payload: {
        // did: values.number,
        // cost: values.cost,
        //   },
        // });
        const data = {
          call: methodNameEnum.ADD_PORT,
          apikey: userAtom.contents?.apikey,
          did: values.number,
          cost: values.cost,
          numberName: values.numberName,
        };
        const response = await mutation.mutateAsync({
          endpoint: endpointEnum.ADD_PORT,
          payload: data,
        });
        if (response?.data?.success) {
          enqueueSnackbarWithStyles({
            message: `Succesfully Ported in the Number ${values.number}.`,
            alertProps: { severity: 'success' },
          });
        } else {
          enqueueSnackbarWithStyles({
            message: `Duplicate Number ${values.number}.`,
            alertProps: { severity: 'warning' },
          });
        }

        refetchBusinessNumbers();
        handleClose();
        actions.resetForm({});
      }}
      validationSchema={portSchema}
      enableReinitialize={true}
      initialValues={{
        number: '',
        cost: '',
        numberName: '',
      }}
    >
      {(formik) => (
        <ModalWithStyles
          show={show}
          onSubmit={() => {
            trackSaveAddPort();
            formik.handleSubmit();
          }}
          title="Port In a Number "
          aria-labelledby="example-modal-sizes-title-sm"
          onHide={() => {
            formik.resetForm({});
            handleClose();
          }}
          disableSubmit={!formik.isValid}
          isSubmitting={formik.isSubmitting}
          isLoading={formik.isSubmitting}
          size="xs"
        >
          <Box
            {...(isPreventCutOffEnabled && {
              sx: {
                display: 'flex',
                flexDirection: 'column',
                marginTop: '20px',
                gap: '10px',
              },
            })}
          >
            <div className="row">
              <div className="col-8">
                <FormikTextField
                  id="standard-basic"
                  label="Number*"
                  name="number"
                  formik={formik}
                  size="small"
                  variant="outlined"
                  fullWidth
                />
              </div>
              <div className="col-4">
                <FormikTextField
                  id="standard-basic"
                  label="Cost*"
                  name="cost"
                  formik={formik}
                  size="small"
                  variant="outlined"
                  fullWidth
                />
              </div>
            </div>
            <div className="row">
              <div className="col-8">
                <FormikTextField
                  id="standard-basic"
                  label="Name"
                  name="numberName"
                  formik={formik}
                  size="small"
                  variant="outlined"
                  fullWidth
                />
              </div>
            </div>
            {!isPreventCutOffEnabled && <br />}
          </Box>
        </ModalWithStyles>
      )}
    </Formik>
  );
}
